import { flattenDeep, uniq } from 'lodash'

export default function (flights) {
	const segments = flattenDeep(flights.map( flight => flight.segments ))
	const fareIds = segments.map( segment => segment.fareId )
	return uniq(fareIds)
}
